import React from 'react';
import Spinner from '../Controls/Spinner'

const OverlayWaiting = (props) => {
    return (
        <div className="overlay bg-gradient-default text-light text-center">
            <div className="fa-3x">
                <Spinner />
            </div>
            <p className="mb-0 mt-3">
                Please wait...
            </p>
            {props.message &&
                <p className="mb-0 mt-3">
                    {props.message}
                </p>
            }
        </div>
    );
}

export default OverlayWaiting;